import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { useChannelList } from '@/api/channel';
import {
  CategoryFilter,
  ComboboxPickerFilter,
  encodeFilterFieldName,
  FilterField,
  useFilterForm,
} from '@/components/filters';
import type { FilterOperatorMulti } from '@/components/InstantSearch';
import type { FilterComponentProps } from '@/providers/TableState';

type Props = FilterComponentProps & {
  mode?: 'multiple' | 'single';
  hasExclude?: boolean;
};

const ChannelFilter = ({
  name,
  label,
  infoPopover,
  compact = false,
  mode = 'multiple',
  hasExclude = true,
}: Props) => {
  const form = useFilterForm();
  const { channels, isLoading, error } = useChannelList();

  return (
    <form.AppField name={encodeFilterFieldName(name)}>
      {(field) => (
        <FilterField
          data-testid="channel-filter"
          label={label}
          infoPopover={infoPopover}
          hideLabel={!compact}
        >
          {compact ? (
            <ComboboxPickerFilter
              value={field.state.value as FilterOperatorMulti}
              onChange={field.handleChange}
              items={channels}
              isLoading={isLoading}
              error={error}
              mode={mode}
              hasExclude={hasExclude}
              singlePlaceholder={t`Select Channel...`}
              multiplePlaceholder={t`Select Channels...`}
              multipleLoadingPlaceholder={t`Loading Channels...`}
              notFoundContent={<Trans>No channels were found...</Trans>}
            />
          ) : (
            <CategoryFilter
              value={field.state.value as FilterOperatorMulti}
              onChange={field.handleChange}
              selectionMode={mode}
              isLoading={isLoading}
              error={error}
              options={channels}
            />
          )}
        </FilterField>
      )}
    </form.AppField>
  );
};

export default ChannelFilter;
